/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedTitle_buyPage$ref = any;
export type BuySharedTitle_buyPage = {
    readonly totalResults: number | null;
    readonly metadata: {
        readonly header: string | null;
    } | null;
    readonly " $refType": BuySharedTitle_buyPage$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedTitle_buyPage",
  "type": "BuyPageConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalResults",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "metadata",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '876c57b43b9d7a16cc480c19cad821cb';
export default node;
